import { gql } from '@apollo/client'

export const INVENTORY_ALLOCATE_AVAILABILITY = gql`
  mutation Allocate($input: AllocateInput!) {
    allocate(input: $input) {
      trackingID
      message
    }
  }
`

// Query for allocated list (room types, channels, and their details)
export const INVENTORY_ALLOCATE_LIST = gql`
  query AllocatedList($input: AllocatedListInput!) {
    allocatedList(input: $input) {
      roomtypes {
        basicDetails {
          name
          roomtypeCode
          displayRoomTypeCode
          numberOfRooms
        }
        providers {
          detailsForEachDate {
            date
            totalAvailability
            totalAllocatedAvailability
            pooledAvailability
          }
          channels {
            basicDetails {
              name
              id
              channels {
                basicDetails {
                  name
                  channelID
                }
                detailsForEachDate {
                  date
                  allocatedAvailability
                }
              }
            }
            detailsForEachDate {
              date
              totalAvailability
              totalAllocatedAvailability
              pooledAvailability
              otherProviderChannels {
                channelName
                channelID
                providerName
                providerID
                allocatedAvailability
              }
              allocatedAvailability
            }
          }
        }
      }
    }
  }
`

// Mutation to retry a failed allocation
export const INVENTORY_RETRY_FAILED_ALLOCATION = gql`
  mutation RetryFailedAllocation($requestID: String!) {
    retryFailedAllocation(requestID: $requestID) {
      trackingID
      message
    }
  }
`

export const ALLOCATE_HISTORY = gql`
  query AllocateHistory($input: AllocateHistoryInput!) {
    allocateHistory(input: $input) {
      time
      action
      status
      delta
      operationType
      systemReservations {
        reservationNumber
        operationType
        time
      }
      references {
        requestId
        bookingNumber
        bookingVersion
      }
    }
  }
`
export const ALLOCATION_SYSTEM_RESERVES = gql`
  query AllocationSystemReserves($input: AllocationSystemReservesInput!) {
    allocationSystemReserves(input: $input) {
      reservationNumber
      operationType
      time
    }
  }
`
export const ALLOCATION_LOGS = gql`
  query AllocationLogs($input: AllocationLogsInput!) {
    allocationLogs(input: $input) {
      logs {
        userEmail
        requestTime
        allocationRange {
          from
          to
        }
        channelCode
        channelName
        roomTypeCode
        roomTypeName
        propertyCode
        accommodationName
        action
        delta
        status
        canRetry
        requestID
      }
      total
    }
  }
`
export const ALLOCATION_LOG_DETAILS = gql`
  query AllocationLogDetails($requestId: String!) {
    allocationLogDetails(requestId: $requestId) {
      userEmail
      requestTime
      allocationRange {
        from
        to
      }
      channelCode
      channelName
      roomTypeCode
      roomTypeName
      propertyCode
      accommodationName
      action
      delta
      status
      canRetry
      attempts {
        name
        userEmail
        time
        dailyAllocationDetails {
          date
          successful
          requested
          status
        }
        attemptId
      }
      totalDailyAllocationDetails {
        date
        successful
        requested
        status
      }
    }
  }
`
export const ALLOCATION_RESERVATION_LOG_DETAILS = gql`
  query AllocationReservationLogDetails($attemptId: String!, $date: String!) {
    allocationReservationLogDetails(attemptId: $attemptId, date: $date) {
      date
      successful
      requested
      failed
      name
      userEmail
      systemReserves {
        status
        failedReason
        reservationNumber
        canRetry
      }
    }
  }
`
export const ALLOCATION_MISMATCHES_QUERY = gql`
  query AllocationMismatches($input: AllocateMismatchesInput!) {
    allocationMismatches(input: $input) {
      propertyCode
      roomType
      date
      CRSTotalAllocate
      sumOfChannelAllocates
      mismatchType
      notes
      bookingListReservationNumbers
      allocateHistoryReservationNumbers
    }
  }
`

export const FIX_MANUAL_CANCEL_MUTATION = gql`
  mutation fixManualCancel($reservationNumber: String!) {
    fixManualCancel(reservationNumber: $reservationNumber) {
      message
    }
  }
`
